import React from 'react';
import { useConfiguration } from "src/hooks/Configuration"
import { BlockContainerModal, Image, Paragraph, TextContainer, Title } from "../../styles"
import SocialShareSpeaker from "../SocialShare";
import { websitePath } from 'src/config';

const SpeakerModal = ({content, component_styles}) => {
 

const speakerComponentImage = JSON.parse(JSON.stringify(component_styles || {}));;

if(!speakerComponentImage?.computer){
speakerComponentImage.computer = {
    
}

 
}

if(!speakerComponentImage?.mobile){
 

speakerComponentImage.mobile = {
 
}

}


 
speakerComponentImage.computer.image_size = '200px';
speakerComponentImage.mobile.image_size = '100%';

speakerComponentImage.computer.title_text_align = 'left';
speakerComponentImage.mobile.title_text_align = 'left';
speakerComponentImage.computer.title_padding = '5px 10px';
speakerComponentImage.mobile.title_padding = '5px 10px';

speakerComponentImage.computer.description_padding = '5px 10px';
speakerComponentImage.computer.description_text_align = 'left';
speakerComponentImage.mobile.description_padding = '5px 10px';
speakerComponentImage.mobile.description_text_align = 'left';
 


 

return <BlockContainerModal component_styles={component_styles}>
    <div className="column">
                {content?.photo ?
                    <Image component_styles={{...speakerComponentImage }} src={`${websitePath}/${content?.photo}`} style={{ width: '150px', borderRadius: content?.['border-radius'] || '0px' }} />
                   
                    : <></>}
                    { content?.country_image ? <img src={`${websitePath}/${content?.country_image}`} style={{width: '50px',  borderRadius:'3px'}}/> : <></>}
                     <SocialShareSpeaker socialIcons={content?.social} color="#333" size="20" />
                     </div>
                <TextContainer component_styles={{...speakerComponentImage }}>
                    {content?.name ? <Title component_styles={{...speakerComponentImage }}>{content?.name}</Title> : <></>}
                    {content?.description ? <Paragraph component_styles={{...speakerComponentImage }} dangerouslySetInnerHTML={{ __html: content?.description }} /> : <></>}
                </TextContainer>
            </BlockContainerModal>


}

export default SpeakerModal;